import { useState, useMemo } from 'react';
import { MagpieConnection } from 'magpie-lib/connection';
import { targetElementRectsMessages } from '../communication/targetElementRects.messages';
import { targetElementRectsTopic } from '../communication/targetElementRects.topic';
import { useEffectOnce } from '../hooks/useEffectOnce';
import { useResizeObserveElements } from '../hooks/useResizeObserveElements';
import { useWindowScrollEvent } from '../hooks/useWindowEvents';
import { useWindowResizeEvent } from '../hooks/useWindowEvents';
import { maybeSendTargetElementRectsUpdate } from '../communication/targetElementRects.publishers';
import { onTargetElementRectsRequest } from '../communication/targetElementRects.subscribers';
import { useSetupLogger } from '../hooks/useSetupLogger';
export const TargetElementObserver = ({
  onError
}) => {
  const [targetElementsToRects, setTargetElementsToRects] = useState({});
  useSetupLogger(onError);
  const selectors = useMemo(() => Object.keys(targetElementsToRects), [targetElementsToRects]);
  const sendTargetElementRectsUpdate = useMemo(() => maybeSendTargetElementRectsUpdate(targetElementsToRects), [targetElementsToRects]);

  // We listen for the target element rects requests
  useEffectOnce(() => {
    const unsubscribe = MagpieConnection.get().useTopic(targetElementRectsTopic).on(targetElementRectsMessages.requestTargetElementRects.getType(), onTargetElementRectsRequest(setTargetElementsToRects));
    return () => {
      unsubscribe();
    };
  });
  useResizeObserveElements(sendTargetElementRectsUpdate, selectors);
  useWindowScrollEvent(sendTargetElementRectsUpdate);
  useWindowResizeEvent(sendTargetElementRectsUpdate);
  return null;
};